module["exports"] = ["ایران"];